import axios from "axios";
import router from '../router'
import { message, Modal } from 'ant-design-vue';
import i18n from '@/locales/i18n'


const http = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        "Content-Type": "application/json; charset=UTF-8",
    }
});

http.defaults.withCredentials = true;

http.defaults.transformResponse = [
    // data => {
    //     // 为每个请求自动注入 meta, 请求可以直接传 params 下面的对象，也可以传整个{ params: object, meta: object, page?: object }
    //     const meta = getMeta();
    //     const payload = this.has(data, "params")
    //         ? {
    //             meta,
    //             ...data
    //         }
    //         : {
    //             meta,
    //             params: data
    //         };
    //     return JSON.stringify(payload);
    // }
    res => {
        return res;
    }
];
http.interceptors.request.use(
    config => {
        // 判断本地的cookie中是否有token
        let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
        if (userInfo && userInfo.Authorization != '') {
            // console.log(' userInfo.Authorization === ', userInfo.Authorization);
            config.headers.Authorization = userInfo.Authorization;
        } else {
            // message.error("登录失效，请重新登录！"); // 这里要做接口判断，放行登录接口，登录接口不需要token
            // 跳转到登录页面(这里使用router，是因为路由文件引入到了此文件里)
            router.push('/login')
        }
        return config;
    },
    err => {
        return err;
    }
);
http.interceptors.response.use(
    resp => {
        let data = resp.data
        if (resp.status && resp.status == 200 && resp.data.status == 'error') {
            // message.error('粗偶');
            return;
        }
        // 处理状态码正常的错误
        if (data) {
            try {
                let resp = JSON.parse(data)
                if (resp.success === false) {
                    // message.error(resp.msg )
                    if (resp.code == '100') {
                        message.error(resp.msg || i18n.t('unknownMistake'));
                        Modal.destroyAll();
                        router.push('/login')
                        return;
                    }
                }
            } catch (error) {
                console.log(error)
            }
        }
        return resp;
    },
    err => {
        // console.log('errerr',err)
        if (err.response.status == 504 || err.response.status == 404) {
            message.error(i18n.t('serverDeserting'));
        } else if (err.response.status == 403) {
            message.error(i18n.t('insufficientPermissions'));
        } else if (err.response.status === 401) {
            const errInfo = JSON.parse(err.response.data) || {};
            message.error(errInfo.msg || i18n.t('unknownMistake'));
            Modal.destroyAll();
            router.replace('/login');
        } else {
            // const data = JSON.parse(err?.response?.data ?? '{}')
            message.error(i18n.t('unknownMistake'));
        }
        return Promise.resolve(err);
    }
);

const newHttp = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        "Content-Type": "application/json; charset=UTF-8",
    }
});
newHttp.interceptors.request.use(
    config => {
        // 判断本地的cookie中是否有token
        let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
        if (userInfo && userInfo.Authorization != '') {
            // console.log(' userInfo.Authorization === ', userInfo.Authorization);
            config.headers.Authorization = userInfo.Authorization;
        }
        return config;
    },
    err => {
        return err;
    }
);
newHttp.interceptors.response.use(
    resp => {
        let data = resp.data
        if (resp.status && resp.status == 200 && resp.data.status == 'error') {
            return;
        }
        if (data) {
            try {
                let resp = JSON.parse(data)
                if (resp.success === false) {
                    if (resp.code == '100') {
                        return;
                    }
                }
            } catch (error) {
                console.log(error)
            }
        }
        return data;
    },
    err => {
        return Promise.resolve(err);
    }
);

function getMeta(data = {}) {
    return {
        code: "duckbill-agent-tms-client",
        client: "PC",
        tag: "duckbill-agent-tms-client",
        time: Date.now(),
        ...data
    };
}
const getApiUrl = (path = '') => {
    // 所有接口使用浏览器域名访问接口
    if (!path) return path;
    if (path.startsWith('/api')) return path;
    return path.startsWith('/') ? `/api${path}` : `/api/${path}`;
};
export { http, getMeta, getApiUrl, newHttp }
